import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { TransferBeneficalOwner } from '../../../Models/Domains/Transfer/TransferBeneficalOwner';

declare var IS_RUNNING_IN_APP_POOL;

export class TransferBeneficialOwnerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(sourceAccountHierarchyId: string, destinationAccountHierarchyId: string): Promise<Array<TransferBeneficalOwner>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/TransferBeneficialOwner/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { sourceAccountHierarchyId: sourceAccountHierarchyId, destinationAccountHierarchyId: destinationAccountHierarchyId }

    return AjaxWrapper.get<Array<TransferBeneficalOwner>, any>(url, data);
  }
}

